<template>
  <div style="padding: 40px;">
    <!-- <div class="layui-card-header">个人信息</div> -->
    <audio src="../../../static/img/y2416.mp3" controls loop ref="audioPlayer" style="display: none;"></audio>
    <div class="layui-card-body user-profile-card">
      <div class="toux">
        <img src="../../assets/img/user.png" alt="" width="100" height="100">
      </div>
      <div id="user-info" style="text-align: left;margin-left: 32%;font-size: 18px;">
        <div style="line-height: 30px;">
          <span class="spanwd">账号名称：</span>
          <span>{{ dataList.username }}</span>
        </div>
        <div style="line-height: 30px;">
          <span class="spanwd">密码：</span>
          <el-button type="warning" @click="modifyPwd" style="font-size: 14px;padding: 10px 20px;">修改密码</el-button>
        </div>
        <div style="line-height: 30px;">
          <span class="spanwd">所属企业：</span>
          <span>{{ dataList.companyName || '暂无所属企业' }}</span>
        </div>
        <div style="line-height: 30px;">
          <span class="spanwd">角色：</span>
          <span>{{ dataList.roleName }}</span>
        </div>
        <div style="line-height: 30px;">
          <span class="spanwd">手机号：</span>
          <span>{{ dataList.mobile ? dataList.mobile : '暂无电话信息' }}</span>
          <img src="../../assets/img/delete.png" alt="" @click="delmodifymobile" width="24" height="24"
            style="margin-left: 10px;cursor: pointer">
          <img src="../../assets/img/book.png" alt="" @click="modifymobile" width="24" height="24"
            style="margin-left: 10px;cursor: pointer">
        </div>
        <div style="line-height: 30px;">
          <span class="spanwd">邮箱：</span>
          <span>{{ dataList.email ? dataList.email : '暂无电话信息' }}</span>
          <img src="../../assets/img/delete.png" alt="" @click="delemail" width="24" height="24"
            style="margin-left: 10px;cursor: pointer">
          <img src="../../assets/img/book.png" alt="" @click="emailbox" width="24" height="24"
            style="margin-left: 10px;cursor: pointer">
        </div>
        <div style="line-height: 30px;">
          <span class="spanwd">微信昵称：</span>
          <span>{{ dataList.nickName ? dataList.nickName : '暂无绑定微信' }}</span>

          <div style="display: inline-block;cursor: pointer;">
            <viewer>
              <img src="../../../static/img/gzh.jpg" alt="" width="50" height="50">
            </viewer>
          </div>

        </div>
        <div style="line-height: 30px;">
          <span class="spanwd">备注：</span>
          <span style="width: auto;display: inline-flex;">{{ dataList.description ? dataList.description : '暂无简介'
          }}</span>
          <img src="../../assets/img/book.png" alt="" @click="spanwdbox" width="24" height="24"
            style="margin-left: 10px;cursor: pointer">
        </div>
      </div>
    </div>
    <hr>
    <div class="mycenter">
      <div style="padding: 10px 0;font-size: 20px;text-align: left;padding-left: 30%;">
        <span>报表推送：</span>
        <el-checkbox label="周报推送" border v-model="dataForm.isOpenWeek" prop="isOpenWeek"
          v-if="isAuth('user:week')"></el-checkbox>
        <el-checkbox label="月报推送" border v-model="dataForm.isOpenMonth" prop="isOpenMonth"
          v-if="isAuth('user:month')"></el-checkbox>
        <el-checkbox label="年报推送" border v-model="dataForm.isOpenYear" prop="isOpenYear"
          v-if="isAuth('user:year')"></el-checkbox>
      </div>
      <div style="padding: 10px 0;font-size: 20px;text-align: left;padding-left: 30%;">
        <span>告警功能：</span>
        <el-checkbox label="短信告警" border v-model="dataForm.isOpenSms" prop="isOpenSms"
          v-if="isAuth('user:sms')"></el-checkbox>
        <el-checkbox label="邮件告警" border v-model="dataForm.isOpenEmail" prop="isOpenEmail"
          v-if="isAuth('user:email')"></el-checkbox>
        <el-checkbox label="公众号告警" border v-model="dataForm.isOpenWechat" prop="isOpenWechat"
          v-if="isAuth('user:wechat')"></el-checkbox>
        <el-checkbox label="语音告警" border v-model="dataForm.isOpenVoice" prop="isOpenVoice"
          v-if="isAuth('user:voice')"></el-checkbox>
        <el-checkbox label="客户端告警" border v-model="dataForm.isOpenClient" prop="isOpenClient"
          v-if="isAuth('user:client')"></el-checkbox>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dataFormSubmit()" style="width: 200px;font-size: 22px;">保存</el-button>
      </div>
    </div>
    <el-dialog title="修改密码" :visible.sync="modifyPasswordVisible" :modal-append-to-body="false"
      :close-on-click-modal="false" width="400px" height="540px" style="text-align: left;">
      <el-form v-model="modifyPasswordForm">
        <el-form-item label="原密码" :rules="[{ required: true }]">
          <el-input v-model="modifyPasswordForm.odlPassword" auto-complete="off" type="password"></el-input>
        </el-form-item>
        <el-form-item label="新密码" :rules="[{ required: true }]">
          <el-input v-model="modifyPasswordForm.newPassword" auto-complete="off" type="password"></el-input>
        </el-form-item>
        <el-form-item label="密码确认" :rules="[{ required: true }]">
          <el-input v-model="modifyPasswordForm.verifyPassword" auto-complete="off" type="password"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="modifyPasswordVisible = false">取 消</el-button>
        <el-button type="primary" @click="updatePassword">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改手机号" :visible.sync="modifymobilephone" :modal-append-to-body="false"
      :close-on-click-modal="false" width="400px" height="540px" style="text-align: left;">
      <el-form v-model="loginForm">
        <el-form-item label="手机号">
          <el-input v-model="loginForm.mobile" placeholder="请输中国大陆手机号" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="验证码" style="width: 64%;float: left;">
          <el-input v-model="loginForm.code" auto-complete="off"></el-input>
        </el-form-item>
        <el-button type="primary" @click="phone" style="float: right;margin-top: 40px;">发送验证码</el-button>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="modifymobilephone = false">取 消</el-button>
        <el-button type="primary" @click="updateMobile">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { isAuth } from "@/utils";
export default {
  data() {
    return {
      dataList: [],
      modifyPasswordVisible: false,
      modifymobilephone: false,
      loginForm: {
        mobile: "",
        code: ""
      },
      dataForm: {
        isOpenWeek: false,
        isOpenMonth: false,
        isOpenYear: false,
        isOpenSms: false,
        isOpenEmail: false,
        isOpenWechat: false,
        isOpenVoice: false,
        isOpenClient: false
      },
      modifyPasswordForm: {
        odlPassword: "",
        newPassword: "",
        verifyPassword: ""
      },
      checked: true,
      audio: new Audio(),
      isMuted: false
    };
  },
  mounted() {
    this.getUserInfo();
    // this.$refs.audioPlayer.play();
  },
  methods: {
    beep() {
      // 音频测试
      const audioContext = new (window.AudioContext ||
        window.webkitAudioContext)();
      const oscillator = audioContext.createOscillator();
      oscillator.type = "square";
      oscillator.frequency.setValueAtTime(440, audioContext.currentTime); // 440Hz 是A音
      const gainNode = audioContext.createGain();
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      oscillator.start();

      // console.log('AudioContext state:', audioContext.state); // 'running'
      // console.log('Is playing:', this.checkIfPlaying()); // true

      // 5秒后停止并释放
      setTimeout(() => {
        oscillator.stop();
        audioContext.close().then(() => {
          console.log("AudioContext closed");
        });
      }, 3000);
    },
    modifyPwd() {
      this.modifyPasswordVisible = true;
    },
    modifymobile() {
      this.modifymobilephone = true;
    },
    //修改密码
    updatePassword() {
      //新密码 ！= 原密码  新密码==密码确认
      if (
        this.modifyPasswordForm.odlPassword ==
        this.modifyPasswordForm.newPassword
      ) {
        this.$message.warning("新密码不能和原密码一致");
        return;
      }
      if (
        this.modifyPasswordForm.verifyPassword !=
        this.modifyPasswordForm.newPassword
      ) {
        this.$message.warning("新密码要和密码确认不一致");
        return;
      }
      this.$http({
        url: this.$http.adornUrl("/user/password/update"),
        method: "post",
        data: this.$http.adornData(this.modifyPasswordForm)
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.modifyPasswordForm = {};
          this.modifyPasswordVisible = false;
          this.$message({
            message: data.msg,
            type: "success",
            duration: 1000
          });
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    updateMobile() {
      this.$http({
        url: this.$http.adornUrl("/user/mobile/update"),
        method: "POST",
        data: this.$http.adornData(this.loginForm),
        params: this.$http.adornParams({
          code: this.loginForm.code,
          mobile: this.loginForm.mobile
        })
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.$message.success("修改成功");
          this.modifymobilephone = false;
          this.getUserInfo();
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    //获取手机验证码
    phone() {
      if (this.loginForm.mobile == "") {
        this.$message.error("请输入手机号码不能为空");
      } else {
        this.$http({
          url: this.$http.adornUrl("/sms/send/" + this.loginForm.mobile),
          method: "POST",
          data: this.$http.adornData(this.loginForm)
        }).then(({ data }) => {
          if (data && data.code === 200) {
            this.$message.success("短信发送成功");
          } else {
            this.$message.error(data.msg);
          }
        });
      }
    },
    //删除手机号码
    delmodifymobile() {
      this.$confirm(
        "删除后将无法接收短信或语音告警,请确认是否删除当前手机号?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.$http({
            url: this.$http.adornUrl("user/profile/update"),
            method: "POST",
            data: this.$http.adornParams({
              mobile: ""
            })
          }).then(({ data }) => {
            if (data && data.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.getUserInfo();
            } else {
              this.$message.error(data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //邮箱
    emailbox() {
      this.$prompt("请输入邮箱", "修改邮箱", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: "邮箱格式不正确"
      })
        .then(({ value }) => {
          this.$http({
            url: this.$http.adornUrl("/user/profile/update"),
            method: "POST",
            data: this.$http.adornParams({
              email: value
            })
          }).then(({ data }) => {
            if (data && data.code === 200) {
              this.$message({
                type: "success",
                message: "修改完成"
              });
              this.getUserInfo();
            } else {
              this.$message.error(data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入"
          });
        });
    },
    spanwdbox() {
      this.$prompt("备注：", "修改备注", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(({ value }) => {
          this.$http({
            url: this.$http.adornUrl("/user/profile/update"),
            method: "POST",
            data: this.$http.adornParams({
              description: value
            })
          }).then(({ data }) => {
            if (data && data.code === 200) {
              this.$message({
                type: "success",
                message: "修改完成"
              });
              this.getUserInfo();
            } else {
              this.$message.error(data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入"
          });
        });
    },
    //删除邮箱
    delemail() {
      this.$confirm(
        "删除后将无法接收邮件告警,请确认是否删除当前邮箱?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.$http({
            url: this.$http.adornUrl("/user/profile/update"),
            method: "POST",
            data: this.$http.adornParams({
              email: ""
            })
          }).then(({ data }) => {
            if (data && data.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.getUserInfo();
            } else {
              this.$message.error(data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    dataFormSubmit() {
      this.$http({
        url: this.$http.adornUrl("/user/profile/update"),
        method: "POST",
        data: this.$http.adornParams({
          isOpenWeek: this.dataForm.isOpenWeek ? 1 : 0,
          isOpenMonth: this.dataForm.isOpenMonth ? 1 : 0,
          isOpenYear: this.dataForm.isOpenYear ? 1 : 0,
          isOpenWechat: this.dataForm.isOpenWechat ? 1 : 0,
          isOpenVoice: this.dataForm.isOpenVoice ? 1 : 0,
          isOpenClient: this.dataForm.isOpenClient ? 1 : 0,
          isOpenSms: this.dataForm.isOpenSms ? 1 : 0,
          isOpenEmail: this.dataForm.isOpenEmail ? 1 : 0
        })
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.$message({
            type: "success",
            message: "保存成功!"
          });
          this.getUserInfo();
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    //获取用户信息
    getUserInfo() {
      this.$http({
        url: this.$http.adornUrl("user/detail"),
        method: "get"
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.dataList = data.data.user;
          this.dataForm = data.data.user;
          if (this.dataForm.isOpenWeek == 1) {
            this.dataForm.isOpenWeek = true;
          }
          if (this.dataForm.isOpenMonth == 1) {
            this.dataForm.isOpenMonth = true;
          }
          if (this.dataForm.isOpenYear == 1) {
            this.dataForm.isOpenYear = true;
          }
          if (this.dataForm.isOpenWechat == 1) {
            this.dataForm.isOpenWechat = true;
          }
          if (this.dataForm.isOpenVoice == 1) {
            this.dataForm.isOpenVoice = true;
          }
          if (this.dataForm.isOpenClient == 1) {
            this.dataForm.isOpenClient = true;
          }
          if (this.dataForm.isOpenSms == 1) {
            this.dataForm.isOpenSms = true;
          }
          if (this.dataForm.isOpenEmail == 1) {
            this.dataForm.isOpenEmail = true;
          }
        }
      });
    },
    //权限
    isAuth(key) {
      return isAuth(key);
    }
  }
};
</script>

<style scoped>
.toux {
  width: 208px;
  background: #ededed;
  height: 218px;
  border-radius: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 5%;
}

.spanwd {
  display: inline-block;
  width: 120px;
  text-align: right;
  font-size: 20px;
}

/deep/ .el-checkbox__inner {
  height: 22px;
  width: 22px;
}

/deep/ .el-checkbox__inner::after {
  height: 12px;
  left: 6px;
  width: 6px;
}

.mycenter .dialog-footer {
  position: fixed;
  bottom: 20px;
  margin: 0 auto;
  width: calc(100% - 240px);
  left: 240px;
  display: flex;
  justify-content: center;
  height: 48px;
}
</style>



// WEBPACK FOOTER //
// src/pages/parameters/mycenter.vue